/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const EligibleState = {
    ELIGIBLE: 'ELIGIBLE',
    EXPIRED: 'EXPIRED',
    PLANNED: 'PLANNED'
} as const;
export type EligibleState = typeof EligibleState[keyof typeof EligibleState];

